

// import React, { useState, useEffect } from "react";
// import {
//   Container,
//   Form,
//   Row,
//   Col,
//   Table,
//   Button,
//   Alert,
// } from "react-bootstrap"; // Added Button and Alert
// import Select from "react-select"; // Import react-select
// import { FaPlus, FaMinus } from "react-icons/fa";
// import useFetchClasses from "../../hooks/useFetchClasses";
// import { ApiUrl } from "../../../ApiUrl";

// const FeeStructure = () => {
//   const {
//     classes,
//     loading: classLoading,
//     error: classError,
//   } = useFetchClasses();
//   const [selectedSession, setSelectedSession] = useState("current");
//   const [feeStructureOptions, setFeeStructureOptions] = useState([]);
//   const [selectedFeeStructure, setSelectedFeeStructure] = useState(null);
//   const [selectedClasses, setSelectedClasses] = useState([]); // State to store selected classes
//   const [showAdditionalTable, setShowAdditionalTable] = useState({});
//   const [alertMessage, setAlertMessage] = useState(""); // State for alert message
//   const [showAlert, setShowAlert] = useState(false); // State to control alert visibility
//   const [feeDetails, setFeeDetails] = useState(null);

//   // Toggle function for plus icon click
//   const handleToggle = (index) => {
//     setShowAdditionalTable((prev) => ({
//       ...prev,
//       [index]: !prev[index],
//     }));
//   };
//   const fetchFeeDetails = async (feeStructureId) => {
//     try {
//       const response = await fetch(
//         `${ApiUrl.apiurl}FEESTRUCTURE/GetFeeDetailsBasedOnFeeStructure/${feeStructureId}`
//       );
//       const data = await response.json();
//       if (data.message === "success") {
//         setFeeDetails(data.data);
//       } else {
//         setFeeDetails(null);
//       }
//     } catch (error) {
//       console.error("Error fetching fee details:", error);
//       setFeeDetails(null);
//     }
//   };
//   // Fetch fee structure based on academic year ID
//   const fetchFeeStructure = async (academicYearId) => {
//     try {
//       const response = await fetch(
//         `${ApiUrl.apiurl}FeeStructure/GetFeeStructureBasedOnAcademicYear/${academicYearId}`
//       );
//       const data = await response.json();
//       if (data.message === "Success") {
//         const options = data.data.map((item) => ({
//           value: item.id,
//           label: item.fee_structure_desc,
//         }));
//         setFeeStructureOptions(options);
//       } else {
//         setFeeStructureOptions([]);
//       }
//     } catch (error) {
//       console.error("Error fetching fee structure:", error);
//       setFeeStructureOptions([]);
//     }
//   };

//   // Fetch previous academic year based on current academicYearId
//   const fetchPreviousAcademicYear = async (academicYearId, orgId, branchId) => {
//     try {
//       const response = await fetch(
//         `${ApiUrl.apiurl}AcademicYear/GetPreviousAcademicYear/${academicYearId}/${orgId}/${branchId}`
//       );
//       const data = await response.json();
//       if (data.message === "success" && data.data.length > 0) {
//         const previousYearId = data.data[0].id; // Get the previous year's academic ID
//         return previousYearId;
//       }
//     } catch (error) {
//       console.error("Error fetching previous academic year:", error);
//       return null;
//     }
//   };

//   // Effect to handle session change and fetch fee structure
//   useEffect(() => {
//     let academicSessionId = localStorage.getItem("academicSessionId");
//     const orgId = localStorage.getItem("orgId");
//     const branchId = localStorage.getItem("branchId");

//     if (academicSessionId && orgId && branchId) {
//       let academicYearId = parseInt(academicSessionId);

//       if (selectedSession === "previous") {
//         fetchPreviousAcademicYear(academicYearId, orgId, branchId).then(
//           (previousYearId) => {
//             if (previousYearId) {
//               fetchFeeStructure(previousYearId);
//             }
//           }
//         );
//       } else {
//         fetchFeeStructure(academicYearId);
//       }
//     }
//   }, [selectedSession]);

//   // Handle class selection
//   const handleClassSelection = (classId) => {
//     setSelectedClasses(
//       (prev) =>
//         prev.includes(classId)
//           ? prev.filter((id) => id !== classId) // Remove if already selected
//           : [...prev, classId] // Add to the selected list
//     );
//   };

//   const handleSave = async () => {
//     // Get academic session, orgId, and branchId from local storage
//     let academicSessionId = localStorage.getItem("academicSessionId");
//     const orgId = localStorage.getItem("orgId");
//     const branchId = localStorage.getItem("branchId");

//     if (!selectedFeeStructure || selectedClasses.length === 0) {
//       setAlertMessage("Please select a fee structure and at least one class.");
//       setShowAlert(true);
//       return;
//     }

//     if (!academicSessionId || !orgId || !branchId) {
//       setAlertMessage("Session or organization data missing.");
//       setShowAlert(true);
//       return;
//     }

//     // Parse academic session ID
//     let academicYearId = parseInt(academicSessionId);

//     // If the selected session is "previous", fetch the previous academic year ID
//     if (selectedSession === "previous") {
//       const previousYearId = await fetchPreviousAcademicYear(
//         academicYearId,
//         orgId,
//         branchId
//       );
//       if (previousYearId) {
//         academicYearId = previousYearId; // Update the academic year ID
//       } else {
//         setAlertMessage("Error fetching previous academic year.");
//         setShowAlert(true);
//         return;
//       }
//     }

//     // Create request body using dynamic academicYearId
//     const requestBody = {
//       loginUser: 1, // Replace with actual logged-in user ID
//       academicyearId: academicYearId,
//       feestructureId: selectedFeeStructure.value,
//       classIds: selectedClasses,
//     };

//     try {
//       const response = await fetch(
//         `${ApiUrl.apiurl}FEESTRUCTURECOPY/copyfeestructure/`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(requestBody),
//         }
//       );
//       const data = await response.json();

//       if (data.message === "Fees applied successfully on selected classes!!") {
//         alert(data.message); // Display popup alert
//       } else {
//         setAlertMessage("Failed to apply fee structure.");
//         setShowAlert(true);
//       }
//     } catch (error) {
//       console.error("Error applying fee structure:", error);
//       setAlertMessage("Error applying fee structure.");
//       setShowAlert(true);
//     }
//   };

//   return (
//     <>
     
//       <div className="row mb-4">
//         <div className="col-12" style={{ border: "1px solid #ccc" }}>
//           <button
//             type="button"
//             className="btn btn-primary me-2"
//             style={{
//               "--bs-btn-padding-y": ".25rem",
//               "--bs-btn-padding-x": ".5rem",
//               "--bs-btn-font-size": ".75rem",
//               width: "150px",
//             }}
//             onClick={handleSave} // Attach the save function
//           >
//             Save
//           </button>

//           <button
//             type="button"
//             className="btn btn-primary me-2"
//             style={{
//               "--bs-btn-padding-y": ".25rem",
//               "--bs-btn-padding-x": ".5rem",
//               "--bs-btn-font-size": ".75rem",
//               width: "150px",
//             }}
//           >
//             Clear
//           </button>
//           <button
//             type="button"
//             className="btn btn-primary me-2"
//             style={{
//               "--bs-btn-padding-y": ".25rem",
//               "--bs-btn-padding-x": ".5rem",
//               "--bs-btn-font-size": ".75rem",
//               width: "150px",
//             }}
//           >
//             Close
//           </button>
//         </div>
//       </div>

//       <Container
//         fluid
//         className="mt-5 p-4"
//         style={{ border: "1px solid #ddd", borderRadius: "5px" }}
//       >
//         <Form>
//           <Row>
//             <Col md={8}>
//               <Row className="mb-4">
//                 <Col md={6}>
//                   <Form.Check
//                     type="radio"
//                     label="Previous Session Fee Structure"
//                     name="session"
//                     checked={selectedSession === "previous"}
//                     onChange={() => setSelectedSession("previous")}
//                   />
//                   <Form.Check
//                     type="radio"
//                     label="Current Session Fee Structure"
//                     name="session"
//                     checked={selectedSession === "current"}
//                     onChange={() => setSelectedSession("current")}
//                     className="mt-3"
//                   />
//                 </Col>
//                 <Col md={6} className="d-flex align-items-center">
//                   <Form.Check
//                     type="checkbox"
//                     label="Copy All Fee Structure from Previous Session"
//                     disabled={selectedSession !== "previous"}
//                   />
//                 </Col>
//               </Row>

//               <Row className="mb-3">
//                 <Col md={6}>
//                   {selectedSession && (
//                     <>
//                       <Form.Label>
//                         {selectedSession === "previous"
//                           ? "Previous Session Fee Structure"
//                           : "Current Session Fee Structure"}
//                       </Form.Label>
//                       <Select
//                         options={feeStructureOptions}
//                         placeholder="Select"
//                         onChange={(option) => {
//                           setSelectedFeeStructure(option);
//                           fetchFeeDetails(option.value); // Fetch fee details when a fee structure is selected
//                         }}
//                       />
//                     </>
//                   )}
//                 </Col>
//               </Row>
//             </Col>

//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Class</Form.Label>
//                 <div
//                   style={{
//                     maxHeight: "300px",
//                     overflowY: "scroll",
//                     border: "1px solid #ddd",
//                     padding: "10px",
//                   }}
//                 >
//                   {classLoading ? (
//                     <p>Loading classes...</p>
//                   ) : classError ? (
//                     <p>Error loading classes: {classError}</p>
//                   ) : (
//                     classes.map((classItem) => (
//                       <Form.Check
//                         key={classItem.id}
//                         type="checkbox"
//                         label={classItem.classname}
//                         checked={selectedClasses.includes(classItem.id)}
//                         onChange={() => handleClassSelection(classItem.id)} // Handle class selection
//                         style={{ marginBottom: "10px" }}
//                       />
//                     ))
//                   )}
//                 </div>
//               </Form.Group>
//             </Col>
//           </Row>
//         </Form>
//       </Container>

//       {/* Conditionally render table based on dropdown selection */}
//       {feeDetails && (
//         <div
//           style={{
//             marginTop: "20px",
//             border: "2px solid #ddd",
//             padding: "20px",
//             borderRadius: "5px",
//           }}
//         >
//           <h5>Selected Session Fee Structure Details</h5>
//           <Table responsive bordered hover>
//             <thead>
//               <tr>
//                 <th></th>
//                 <th>Fee Structure Name</th>
//                 <th>Class</th>
//                 {/* <th>Freeze</th> */}
//                 <th>Version</th>
//                 {/* <th>Valid From</th>
//                 <th>Valid To</th> */}
//                 <th>Category</th>
//                 <th>New/Existing</th>
//               </tr>
//             </thead>
//             <tbody>
//               {/* Main Fee Structure Details */}
//               <tr>
//                 <td>
//                   <FaPlus
//                     onClick={() => handleToggle(0)} // Assuming you manage the showAdditionalTable state using index 0
//                     style={{ cursor: "pointer" }}
//                   />
//                 </td>
//                 <td>
//                   {feeDetails.feemasterStructureDetails.fee_structure_desc}
//                 </td>
//                 <td>{feeDetails.feemasterStructureDetails.classname}</td>
//                 {/* <td>
//                   {feeDetails.feemasterStructureDetails.enabled === "1"
//                     ? "Yes"
//                     : "No"}
//                 </td> */}
//                 <td>{feeDetails.feemasterStructureDetails.version_no}</td>
//                 {/* <td>2023-06-22</td>
//                 <td>2024-07-31</td>{" "} */}
//                 {/* These dates are static, change if needed */}
//                 {/* <td>
//                   {feeDetails.feemasterStructureDetails.category_code === "1"
//                     ? "Regular"
//                     : "Other"}
//                 </td> */}
//                 <td>{feeDetails.feemasterStructureDetails.category_code}</td>
//                 {/* <td>
//                   {feeDetails.feemasterStructureDetails.new_existing === "y"
//                     ? "New"
//                     : "Existing"}
//                 </td> */}

//                 <td>
//                   {feeDetails.feemasterStructureDetails.new_existing === "N"
//                     ? "NEW"
//                     : feeDetails.feemasterStructureDetails.new_existing === "E"
//                     ? "Existing"
//                     : ""}
//                 </td>
//               </tr>

//               {/* Additional Table for Fee Structure Details */}
//               {showAdditionalTable[0] && (
//                 <tr>
//                   <td colSpan="9">
//                     <Table responsive>
//                       <thead>
//                         <tr>
//                           <th>Element Name</th>
//                           <th>Frequency</th>
//                           <th>Amount</th>
//                           <th>Period 1</th>
//                           <th>Period 2</th>
//                           <th>Period 3</th>
//                           <th>Period 4</th>
//                           <th>Period 5</th>
//                           <th>Period 6</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {feeDetails.feestructureDetails.map(
//                           (feeDetail, index) => (
//                             <tr key={index}>
//                               <td>{feeDetail.element_type_name}</td>
//                               <td>{feeDetail.element_frequency_name}</td>
//                               <td>{feeDetail.amount}</td>
//                               <td>{feeDetail.period_1}</td>
//                               <td>{feeDetail.period_2}</td>
//                               <td>{feeDetail.period_3}</td>
//                               <td>{feeDetail.period_4}</td>
//                               <td>{feeDetail.period_5}</td>
//                               <td>{feeDetail.period_6}</td>
//                             </tr>
//                           )
//                         )}
//                       </tbody>
//                     </Table>
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </Table>
//         </div>
//       )}
//     </>
//   );
// };

// export default FeeStructure;



import React, { useState, useEffect } from "react";
import {
  Container,
  Form,
  Row,
  Col,
  Table,
  Button,
  Alert,
} from "react-bootstrap"; // Added Button and Alert
import Select from "react-select"; // Import react-select
import { FaPlus, FaMinus } from "react-icons/fa";
import useFetchClasses from "../../hooks/useFetchClasses";
import { ApiUrl } from "../../../ApiUrl";
import { useNavigate } from "react-router-dom";

const FeeStructure = () => {
  const {
    classes,
    loading: classLoading,
    error: classError,
  } = useFetchClasses();

  const navigate = useNavigate();
  const [selectedSession, setSelectedSession] = useState("current");
  const [feeStructureOptions, setFeeStructureOptions] = useState([]);
  const [selectedFeeStructure, setSelectedFeeStructure] = useState(null);
  const [selectedClasses, setSelectedClasses] = useState([]); // State to store selected classes
  const [showAdditionalTable, setShowAdditionalTable] = useState({});
  const [alertMessage, setAlertMessage] = useState(""); // State for alert message
  const [showAlert, setShowAlert] = useState(false); // State to control alert visibility
  const [feeDetails, setFeeDetails] = useState(null);
  const [copyAllChecked, setCopyAllChecked] = useState(false);

  // Toggle function for plus icon click
  const handleToggle = (index) => {
    setShowAdditionalTable((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };
  const fetchFeeDetails = async (feeStructureId) => {
    try {
      const response = await fetch(
        `${ApiUrl.apiurl}FEESTRUCTURE/GetFeeDetailsBasedOnFeeStructure/${feeStructureId}`
      );
      const data = await response.json();
      if (data.message === "success") {
        setFeeDetails(data.data);
      } else {
        setFeeDetails(null);
      }
    } catch (error) {
      console.error("Error fetching fee details:", error);
      setFeeDetails(null);
    }
  };
  // Fetch fee structure based on academic year ID
  const fetchFeeStructure = async (academicYearId) => {
    try {
      const response = await fetch(
        `${ApiUrl.apiurl}FeeStructure/GetFeeStructureBasedOnAcademicYear/${academicYearId}`
      );
      const data = await response.json();
      if (data.message === "Success") {
        const options = data.data.map((item) => ({
          value: item.id,
          label: item.fee_structure_desc,
        }));
        setFeeStructureOptions(options);
      } else {
        setFeeStructureOptions([]);
      }
    } catch (error) {
      console.error("Error fetching fee structure:", error);
      setFeeStructureOptions([]);
    }
  };

  // Fetch previous academic year based on current academicYearId
  const fetchPreviousAcademicYear = async (academicYearId, orgId, branchId) => {
    try {
      const response = await fetch(
        `${ApiUrl.apiurl}AcademicYear/GetPreviousAcademicYear/${academicYearId}/${orgId}/${branchId}`
      );
      const data = await response.json();
      if (data.message === "success" && data.data.length > 0) {
        const previousYearId = data.data[0].id; // Get the previous year's academic ID
        return previousYearId;
      }
    } catch (error) {
      console.error("Error fetching previous academic year:", error);
      return null;
    }
  };

  // Effect to handle session change and fetch fee structure
  useEffect(() => {
    let academicSessionId = localStorage.getItem("academicSessionId");
    const orgId = localStorage.getItem("orgId");
    const branchId = localStorage.getItem("branchId");

    if (academicSessionId && orgId && branchId) {
      let academicYearId = parseInt(academicSessionId);

      if (selectedSession === "previous") {
        fetchPreviousAcademicYear(academicYearId, orgId, branchId).then(
          (previousYearId) => {
            if (previousYearId) {
              fetchFeeStructure(previousYearId);
            }
          }
        );
      } else {
        fetchFeeStructure(academicYearId);
      }
    }
  }, [selectedSession]);

  // Handle class selection
  const handleClassSelection = (classId) => {
    setSelectedClasses(
      (prev) =>
        prev.includes(classId)
          ? prev.filter((id) => id !== classId) // Remove if already selected
          : [...prev, classId] // Add to the selected list
    );
  };

  const handleSave = async () => {
    let academicSessionId = localStorage.getItem("academicSessionId");
    const orgId = localStorage.getItem("orgId");
    const branchId = localStorage.getItem("branchId");
    const userId = sessionStorage.getItem("userId");

    if (!academicSessionId || !orgId || !branchId || !userId) {
      setAlertMessage("Academic session, organization, or user data missing.");
      setShowAlert(true);
      return;
    }

    if (selectedClasses.length === 0) {
      setAlertMessage("Please select at least one class.");
      setShowAlert(true);
      return;
    }

    if (!copyAllChecked && !selectedFeeStructure) {
      setAlertMessage("Please select a fee structure.");
      setShowAlert(true);
      return;
    }

    const targetAcademicYearId = parseInt(academicSessionId);
    let sourceAcademicYearId = targetAcademicYearId;
    const feeStructureId = copyAllChecked ? null : selectedFeeStructure.value;

    // Handle "previous" session logic
    if (selectedSession === "previous") {
      const previousYearId = await fetchPreviousAcademicYear(
        targetAcademicYearId,
        orgId,
        branchId
      );

      if (previousYearId) {
        sourceAcademicYearId = previousYearId;
      } else {
        setAlertMessage("Error fetching previous academic year.");
        setShowAlert(true);
        return;
      }
    }

    const requestBody = {
      loginUser: parseInt(userId),
      academicyearId: targetAcademicYearId,
      sourceAcademicYearId,
      feestructureId: feeStructureId,
      classIds: selectedClasses,
      copyAll: selectedSession === "previous" && copyAllChecked,
    };

    try {
      const response = await fetch(
        `${ApiUrl.apiurl}FEESTRUCTURECOPY/copyfeestructure/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );

      const data = await response.json();

      if (response.ok && data.message) {
        alert(data.message);
      } else {
        setAlertMessage(data.error || data.message || "Failed to apply fee structure.");
        setShowAlert(true);
      }
    } catch (error) {
      console.error("Error applying fee structure:", error);
      setAlertMessage("Error applying fee structure.");
      setShowAlert(true);
    }
  };

  const handleClear = () => {
    setSelectedSession("current"); // Reset session selection
    setFeeStructureOptions([]); // Clear fee structure options
    setSelectedFeeStructure(null); // Clear selected fee structure
    setSelectedClasses([]); // Clear selected classes
    setShowAdditionalTable({}); // Hide additional table
    setAlertMessage(""); // Clear alert message
    setShowAlert(false); // Hide alert
    setFeeDetails(null); // Clear fee details
  };

  return (
    <div>
      <div className="row mb-3 mx-0">
        <div className="col-12 mb-3 mt-3 d-flex flex-wrap gap-2">
          <button
            type="button"
            className="btn btn-primary me-2"
            style={{
              width: "150px",
            }}
            onClick={handleSave} // Attach the save function
          >
            Save
          </button>

          <button
            type="button"
            className="btn btn-secondary me-2"
            style={{
              width: "150px",
            }}
            onClick={handleClear}
          >
            Clear
          </button>
          <button
            type="button"
            className="btn btn-danger me-2"
            style={{
              width: "150px",
            }}
            onClick={() => navigate("/admin/dashboard")}
          >
            Close
          </button>
        </div>
      </div>

      <div className="row mt-3 mx-2">
        <Form>
          <Row className="custom-section-box ">
            <Col md={8}>
              <Row className="mb-4 mt -5">
                <Col xs={12} md={6} className="mb-3 mb-md-0 mt -5">
                  <Form.Check
                    type="radio"
                    label="Previous Session Fee Structure"
                    name="session"
                    checked={selectedSession === "previous"}
                    // onChange={() => setSelectedSession("previous")}
                    onChange={() => {
                      setSelectedSession("previous");
                      setCopyAllChecked(false); // reset checkbox when session changes
                      setSelectedFeeStructure(null);
                      setFeeDetails(null);
                    }}
                  />
                  <Form.Check
                    type="radio"
                    label="Current Session Fee Structure"
                    name="session"
                    checked={selectedSession === "current"}
                    // onChange={() => setSelectedSession("current")}
                    onChange={() => {
                      setSelectedSession("current");
                      setCopyAllChecked(false); // reset checkbox when session changes
                      setSelectedFeeStructure(null);
                      setFeeDetails(null);
                    }}
                    className="mt-3"
                  />
                </Col>
                <Col
                  xs={12}
                  md={6}
                  className="d-flex align-items-start align-items-md-center"
                >
                  <Form.Check
                    type="checkbox"
                    label="Copy All Fee Structure from Previous Session"
                    disabled={selectedSession !== "previous"}
                    checked={copyAllChecked}
                    onChange={(e) => {
                      setCopyAllChecked(e.target.checked);
                      if (e.target.checked) {
                        setSelectedFeeStructure(null);
                        setFeeDetails(null);
                      }
                    }}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  {selectedSession && (
                    <>
                      <Form.Label>
                        {selectedSession === "previous"
                          ? "Previous Session Fee Structure"
                          : "Current Session Fee Structure"}
                      </Form.Label>
                      <Select
                        options={feeStructureOptions}
                        placeholder="Select"
                        value={selectedFeeStructure}
                        isDisabled={
                          selectedSession === "previous" && copyAllChecked
                        }
                        onChange={(option) => {
                          setSelectedFeeStructure(option);
                          if (option) {
                            fetchFeeDetails(option.value); // Fetch fee details when a fee structure is selected
                          } else {
                            setFeeDetails(null);
                          }
                        }}
                      />
                    </>
                  )}
                </Col>
              </Row>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Class</Form.Label>
                <div
                  style={{
                    maxHeight: "300px",
                    overflowY: "scroll",
                    border: "1px solid #ddd",
                    padding: "10px",
                  }}
                >
                  {classLoading ? (
                    <p>Loading classes...</p>
                  ) : classError ? (
                    <p>Error loading classes: {classError}</p>
                  ) : (
                    classes.map((classItem) => (
                      <Form.Check
                        key={classItem.id}
                        type="checkbox"
                        label={classItem.classname}
                        checked={selectedClasses.includes(classItem.id)}
                        onChange={() => handleClassSelection(classItem.id)} // Handle class selection
                        style={{ marginBottom: "10px" }}
                      />
                    ))
                  )}
                </div>
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </div>

      {/* Conditionally render table based on dropdown selection */}
      {feeDetails && (
        <div
          style={{
            marginTop: "20px",
            border: "2px solid #ddd",
            padding: "20px",
            borderRadius: "5px",
          }}
        >
          <h5>Selected Session Fee Structure Details</h5>
          <Table responsive bordered>
            <thead>
              <tr>
                <th></th>
                <th>Fee Structure Name</th>
                <th>Class</th>
                {/* <th>Freeze</th> */}
                <th>Version</th>
                {/* <th>Valid From</th>
                <th>Valid To</th> */}
                <th>Category</th>
                <th>New/Existing</th>
              </tr>
            </thead>
            <tbody>
              {/* Main Fee Structure Details */}
              <tr>
                <td>
                  <FaPlus
                    onClick={() => handleToggle(0)} // Assuming you manage the showAdditionalTable state using index 0
                    style={{ cursor: "pointer" }}
                  />
                </td>
                <td>
                  {feeDetails.feemasterStructureDetails.fee_structure_desc}
                </td>
                <td>{feeDetails.feemasterStructureDetails.classname}</td>
                {/* <td>
                  {feeDetails.feemasterStructureDetails.enabled === "1"
                    ? "Yes"
                    : "No"}
                </td> */}
                <td>{feeDetails.feemasterStructureDetails.version_no}</td>
                {/* <td>2023-06-22</td>
                <td>2024-07-31</td>{" "} */}
                {/* These dates are static, change if needed */}
                {/* <td>
                  {feeDetails.feemasterStructureDetails.category_code === "1"
                    ? "Regular"
                    : "Other"}
                </td> */}
                <td>{feeDetails.feemasterStructureDetails.category_code}</td>
                {/* <td>
                  {feeDetails.feemasterStructureDetails.new_existing === "y"
                    ? "New"
                    : "Existing"}
                </td> */}

                <td>
                  {feeDetails.feemasterStructureDetails.new_existing === "N"
                    ? "NEW"
                    : feeDetails.feemasterStructureDetails.new_existing === "E"
                    ? "Existing"
                    : ""}
                </td>
              </tr>

              {/* Additional Table for Fee Structure Details */}
              {showAdditionalTable[0] && (
                <tr>
                  <td colSpan="9">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th>Element Name</th>
                          <th>Frequency</th>
                          <th>Amount</th>
                          <th>Period 1</th>
                          <th>Period 2</th>
                          <th>Period 3</th>
                          <th>Period 4</th>
                          <th>Period 5</th>
                          <th>Period 6</th>
                        </tr>
                      </thead>
                      <tbody>
                        {feeDetails.feestructureDetails.map(
                          (feeDetail, index) => (
                            <tr key={index}>
                              <td>{feeDetail.element_type_name}</td>
                              <td>{feeDetail.element_frequency_name}</td>
                              <td>{feeDetail.amount}</td>
                              <td>{feeDetail.period_1}</td>
                              <td>{feeDetail.period_2}</td>
                              <td>{feeDetail.period_3}</td>
                              <td>{feeDetail.period_4}</td>
                              <td>{feeDetail.period_5}</td>
                              <td>{feeDetail.period_6}</td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </Table>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      )}
    </div>
  );
};

export default FeeStructure;















































